'use strict';

var network = require('./network.cjs');

function enrichXhrBreadcrumb(breadcrumb, hint) {
  const { xhr, input } = hint;
  const { data } = breadcrumb;
  const reqSize = data.request_body_size ?? network.getBodySize(input);
  const resSize = data.response_body_size ?? getResponseBodySize(xhr);
  const serverTiming = getXhrResponseHeader(hint.xhr, "server-timing");
  if (reqSize !== void 0) {
    data.request_body_size = reqSize;
  }
  if (resSize !== void 0) {
    data.response_body_size = resSize;
  }
  if (serverTiming) {
    data.server_timing = serverTiming;
  }
}
function getResponseBodySize(xhr) {
  const contentLength = getXhrResponseHeader(xhr, "content-length");
  if (contentLength) {
    return network.parseContentLengthHeader(contentLength);
  }
  const { response: body, responseType } = xhr;
  const isJsonBody = responseType === "json" && body && typeof body === "object";
  try {
    const bodyStr = isJsonBody ? JSON.stringify(body) : body;
    return network.getBodySize(bodyStr);
  } catch {
    return void 0;
  }
}
function getXhrResponseHeader(xhr, header) {
  try {
    if (xhr.getAllResponseHeaders().indexOf(header) >= 0) {
      return xhr.getResponseHeader(header);
    }
    return null;
  } catch {
    return null;
  }
}

exports.enrichXhrBreadcrumb = enrichXhrBreadcrumb;
//# sourceMappingURL=xhr.cjs.map
